import { OepaUserAccount } from "@ohioepa/oepa-common-lib";

export const intLiveReloadAccount: OepaUserAccount = {
    loginName: 'pmontoto',
    accountID: 'pmontoto',
    firstName: 'Pelayo',
    lastName: 'Montoto',
    corePersonID: {
      value: 5035
    },
    // loginName: 'rbouder',
    // accountID: 'rbouder',
    // firstName: 'Richard',
    // lastName: 'Bouder',
    // corePersonID: {
    //   value: 4191
    // },
    primaryEMailAddress: 'pelayo.montoto@epa.ohio.gov',
    type: 'APPLICATION_PORTAL',
    roleList: [
      {
        name: 'StarsRoles',
        description: 'Stars User Role',
        privilegeList: [
          { type: 'RETRIEVE_REVENUE', name: 'Retrieve Revenue'}
        ]
      }
    ]
  }
